import React from "react";
import moment from "moment";
import {
  Drawer,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Divider
} from "antd";
import InputMask from "react-input-mask";
import { dateToBr } from "../../../../helpers/functions";

const Option = Select.Option;
const { MonthPicker } = DatePicker;
const InputGroup = Input.Group;

const baseNcmOptions = [
  { id: Math.random(), value: 1, text: "ICMS ST" },
  { id: Math.random(), value: 2, text: "ICMS Próprio" },  
  { id: Math.random(), value: 5, text: "NCM possui possibilidade de ser ICMS Próprio e ICMS ST"},
  { id: Math.random(), value: 103, text: "CEST inválida para esta NCM no estado" },
  { id: Math.random(), value: 101, text: "CEST não vigente" },
  { id: Math.random(), value: 102, text: "NCM não vigente" },
  { id: Math.random(), value: 4, text: "NCM não encontrada" }
];

const currentOptions = [
  { id: Math.random(), value: 1, text: "ICMS ST" },
  { id: Math.random(), value: 2, text: "ICMS Próprio" },
  { id: Math.random(), value: 3, text: "Antecipação com encerramento de tributação de ICMS"}  
];

const DrawerFilter = props => {
  const {
    sCodigoProduto,
    sDescricao,
    sNcm,
    sCest,
    sEx,
    sEan,
    sPeriodo
  } = props.filter;

  const {
    vazioNcm,
    vazioCest,
    vazioEX
  } = props.dropdown;

  async function cleanFilters() {
    await props.handleReset();
    props.handleFilters();
  }

  return (
    <Drawer
      title="Filtrar produtos"
      className="ant-drawer--custom"
      width={600}
      onClose={() => props.onClose("visibleDrawerFilter")}
      visible={props.visibleDrawer}
    >
      <Form layout="vertical" hideRequiredMark>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Descrição">
              <Input
                className="form-control"
                name="Descricao"
                value={sDescricao && sDescricao.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Código do Item">
              <Input
                className="form-control"
                name="CodigoProduto"
                value={sCodigoProduto && sCodigoProduto.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="NCM">
              <InputGroup compact>
                <Select value={(vazioNcm ? "Vazio" : "Selecionar")} style={{ width: '107px' }} onChange={props.handleDropdownNcm}>
                  <Option value="Selecionar">Selecionar</Option>
                  <Option value="Vazio">Vazio</Option>
                </Select>
                <InputMask
                  className="form-control"
                  disabled={vazioNcm}
                  style={{ width: '160px', height: '33px' }}
                  name="Ncm"
                  value={sNcm ? sNcm.substr(1) : ""}
                  mask={"9999.99.99"}
                  onChange={props.handleChangeField}
                />
              </InputGroup>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Cest">
              <InputGroup compact>
                <Select value={(vazioCest ? "Vazio" : "Selecionar")} style={{ width: '107px' }} onChange={props.handleDropdownCest}>
                  <Option value="Selecionar">Selecionar</Option>
                  <Option value="Vazio">Vazio</Option>
                </Select>
                <InputMask
                  className="form-control"
                  name="Cest"
                  disabled={vazioCest}
                  style={{ width: '160px', height: '33px' }}
                  value={sCest ? sCest.substr(1) : ""}
                  mask={"99.999.99"}
                  onChange={props.handleChangeField}
                />
              </InputGroup>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="EX">
              <InputGroup compact>
                <Select value={(vazioEX ? "Vazio" : "Selecionar")} style={{ width: '107px' }} onChange={props.handleDropdownEX}>
                  <Option value="Selecionar">Selecionar</Option>
                  <Option value="Vazio">Vazio</Option>
                </Select>
                <Input
                className="form-control"
                name="Ex"
                disabled={vazioEX}
                value={sEx && sEx.substr(1)}
                style={{ width: '160px', height: '33px' }}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
              />
              </InputGroup>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="EAN">
              <Input
                className="form-control"
                name="Ean"
                value={sEan && sEan.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
              />
            </Form.Item>
          </Col>
          {!sPeriodo ? (
            <Col span={12}>
              <Form.Item label="e-Consulta">
                <Select
                  className="ant-select--custom"
                  defaultValue={props.selectedBaseNcm}
                  value={props.selectedBaseNcm}
                  onChange={e => props.handleChangeField(e, "BaseNcm")}
                >
                  <Option value={null}>Todos</Option>
                  {baseNcmOptions.map(item => {
                    return (
                      <Option key={item.id} value={item.value}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
        </Row>

        <Divider className="mt-0" />

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Período">
              <MonthPicker
                className="ant-calendar--custom"
                name="Periodo"
                value={
                  sPeriodo
                    ? moment(dateToBr(sPeriodo.substr(1)), "MM/YYYY")
                    : null
                }
                format="MM/YYYY"
                onChange={(e, val) => props.handleChangeField("Periodo", val)}
              />
            </Form.Item>
          </Col>
          {sPeriodo ? (
            <Col span={12}>
              <Form.Item label="Tributação Considerada">
                <Select
                  className="ant-select--custom"
                  defaultValue={props.selectedCurrent}
                  value={props.selectedCurrent}
                  onChange={e =>
                    props.handleChangeField(e, "BaseClassificacaoUsuario")
                  }
                >
                  <Option value={null}>Todos</Option>
                  {currentOptions.map(item => {
                    return (
                      <Option key={item.id} value={item.value}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
        </Row>
      </Form>

      <div className="ant-drawer__footer">
        <Button className="mr-3" onClick={() => cleanFilters()}>
          Limpar
        </Button>

        <Button
          onClick={() => {
            props.handleFilters();
            props.onClose("visibleDrawerFilter");
          }}
          type="primary"
        >
          Filtrar
        </Button>
      </div>
    </Drawer>
  );
};

export default DrawerFilter;
